<template>
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.6106 42.3566C46.2177 41.6055 46.1035 40.5233 45.3469 39.9251L32.2188 29.619C36.6926 22.8407 35.2905 13.7115 28.7149 8.54572C21.6722 2.99893 11.32 4.08238 
          5.63413 10.9389C-0.0582166 17.8032 1.06296 27.8787 8.11142 33.4131C11.0566 35.7194 14.6483 36.958 18.3788 36.958C18.9723 36.958 19.5624 36.9241 20.1465 
          36.874L20.1551 36.8731C23.9255 36.4817 27.3605 34.8663 30.0069 32.2976L43.1501 42.6157L43.1551 42.6195C43.4716 42.8615 43.8626 43 44.2479 43C44.7576 43 45.2744 
          42.7764 45.6106 42.3566ZM31.7994 20.8906C31.7709 17.1178 30.0709 13.3876 26.8213 10.8394C24.3512 8.89672 21.3904 7.95832 18.4295 7.95832C14.5212 7.95832 10.6299 
          9.60464 7.99052 12.7985C6.02836 15.1672 5.0053 18.0491 5.02232 21.0404C5.02487 21.479 5.04978 21.9199 5.09737 22.3619C5.4865 25.8192 7.22916 28.9307 10.0039 
          31.1203C12.7955 33.3099 16.2808 34.2977 19.8338 33.9355C23.3868 33.5569 26.5845 31.8611 28.8347 29.1612C30.8513 26.7262 31.821 23.7958 31.7994 20.8906Z"
        fill="white"
      />
    </g>
  </svg>
</template>
